/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
/* eslint-disable consistent-return */
/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getContactFormValuesFromSS } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import InputCheckbox from '@tcp/core/src/components/common/atoms/InputCheckbox';
import Espot from '@tcp/core/src/components/common/molecules/Espot';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getIconPath } from '@tcp/core/src/utils/utils';
import { getViewportInfo } from '@tcp/core/src/utils';
import { scrollToFirstError } from '@tcp/core/src/components/features/CnC/Checkout/util/utility';
import briteVerifyStatusExtraction from '@tcp/core/src/services/abstractors/common/briteVerifyStatusExtraction';
import GlobalFormValidationLabels, {
  GLOBAL_FORM_VALIDATION_LABELS,
} from '@tcp/core/src/utils/labels/globalFormValidation.labels';
import Styles from '../styles/CreateAccountForm.style';
import createValidateMethod from '../../../../../../../utils/formValidation/createValidateMethod';
import getStandardConfig from '../../../../../../../utils/formValidation/validatorStandardConfig';
import { isCanada, isClient } from '../../../../../../../utils';
import {
  formatPhoneNumber,
  removeSpaces,
} from '../../../../../../../utils/formValidation/phoneNumber';
import constants from '../../../CreateAccount.constants';
import PasswordIndicator from '../../PasswordIndicator/index';
import { PasswordField } from '../../../../common/molecule/PasswordField/views/PasswordField.view';
import Anchor from '../../../../../../common/atoms/Anchor/views/Anchor';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_REGISTRATION_LABELS,
  GlobalRegistrationLabels,
} from '../../../../../../../utils/labels/globalRegistrations.labels';
import CREATE_ACCOUNT_LABELS from '../../../container/CreateAccount.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblCreateAccount,
  lblFirstName,
  lblLastName,
  lblPhoneNumber,
  lblZipCode,
  lblEmailAddress,
  lblPassword,
  lblDetails,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
  lblLoginCreateAcntBtn,
} from '../../../../../../../utils/labels/globalLogin.labels';
import ReduxFormIntlTelInput from '../../../../../../common/atoms/CustomPhoneNumber/views/CustomPhoneNumberInput';

const UseFocus = () => {
  const htmlElRef = useRef(null);
  const setFocus = () => {
    // eslint-disable-next-line no-unused-expressions
    const elem = htmlElRef && htmlElRef.current;
    // Set Focus at the end of the text instead of start
    const focusTimeout = setTimeout(() => {
      elem.focus();
      if (elem.setSelectionRange) {
        const { length } = elem.value;
        elem.setSelectionRange(length, length);
      }

      clearTimeout(focusTimeout);
    }, 0);
  };

  return [htmlElRef, setFocus];
};

const shouldCallSubmit = (prev, next) => prev && next && prev === next;

export const focusFirstFieldForDesktop = (setFirstNameFocus, isUserLoggedIn) => {
  const { isMobile = false } = getViewportInfo() || {};
  if (isClient() && !isUserLoggedIn && !isMobile) {
    setFirstNameFocus();
  }
};

const handleMouseDown = (e) => {
  const passwordField = document.querySelector('#password');
  if (document.activeElement === passwordField && e?.target?.type === 'checkbox') {
    e.target.click();
  }
};

// eslint-disable-next-line import/no-mutable-exports
let CreateAccountForm = ({
  isMakeDefaultDisabled,
  handleSubmit,
  className,
  userplccCardNumber,
  userplccCardId,
  onSubmit,
  isUserLoggedIn,
  isLoading,
  isNewRegisteredFlow,
  onAlreadyHaveAnAccountClick,
  isBonusPointsEventMessagingEnabled,
  setOnSubmitLoader,
  setOffSubmitLoader,
  isInternationalPhoneNumberEnabled,
  dispatchFormFieldChange,
  isUpdatedCanadaTermsAndConditions,
}) => {
  const formValidationErrorLabels = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_FORM_VALIDATION_LABELS}`,
    GlobalFormValidationLabels
  );
  const [passwordFieldFocus, setPasswordFieldFocus] = useState(false);
  const [passwordValue, setPasswordValue] = useState(null);
  const [invalidEmail, setInvalidEmail] = useState(null);
  const [briteVerifyStatus, setBriteVerifyStatus] = useState(null);
  const [inputRef, setInputFocus] = UseFocus();
  const [firstNameRef, setFirstNameFocus] = UseFocus();
  const containerRef = useRef(null);

  const {
    lbl_createAccount_plcc_checkbox_Text: lblCreateAcntPlccCheckboxText,
    lbl_createAccount_alreadyAccount: lblCreateAcntAlready,
    lbl_createAccount_rememberMe: lblCreateAcntRememberMe,
    lbl_createAccount_rememberMeHelpText: lblCreateAcntRememberDevice,
  } = getLabelFromCopyOrFromTranslation(GLOBAL_REGISTRATION_LABELS, GlobalRegistrationLabels);
  const {
    lbl_createAccount_termsConditions: lblCreateTermsAndConditions,
    lbl_createAccount_termsConditions_1: lblCreateTermsAndConditions1,
    lbl_createAccount_termsConditions_CA: lblCreateTermsAndConditionsCA,
    lbl_createAccount_privacyPolicy_CA: lblCreatePrivacyPolicyCA,
    lbl_createAccount_marketingSubscription_CA: lblMarketingSubscriptionCA,
    lbl_login_bonus_points_messaging_1: lblLoginBonusPoints1,
    lbl_login_bonus_points_messaging_2: lblLoginBonusPoints2,
    lbl_login_bonus_points_event_banner_account_message: lblLoginBonusPointsMessage,
  } = getDynamicLabelValues('dynamic.account_d');

  const globalGenericLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_GENERIC_LABELS,
    GlobalGenericLabels
  );

  const getPlccLbl = lblCreateAcntPlccCheckboxText?.replace('#number', `${userplccCardNumber}`);
  useEffect(() => {
    document.removeEventListener('mousedown', handleMouseDown);
    document.addEventListener('mousedown', handleMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  const handleBriteVerifyStatus = (emailAddress, payload) => {
    return briteVerifyStatusExtraction(emailAddress)
      .then((status) => {
        if (!invalidEmail && status && status.indexOf('invalid') !== -1) {
          setInvalidEmail(emailAddress);
          setBriteVerifyStatus(status);
          return Promise.reject();
        }
        onSubmit({ ...payload, emailValidationStatus: status });
        return Promise.resolve();
      })
      .catch(() => {
        setOffSubmitLoader();
        const error = {
          emailAddress: renderLabel(
            formValidationErrorLabels.lbl_err_email_req,
            'lbl_err_email_req'
          ),
        };
        throw new SubmissionError({ ...error, _error: error });
      });
  };

  const submitFormNewFlow = (formData) => {
    setOnSubmitLoader();
    const contactFormValuesFromSS = getContactFormValuesFromSS();
    const { emailAddress } = { ...contactFormValuesFromSS };
    if (emailAddress) {
      const payload = { ...formData, emailAddress };
      if (shouldCallSubmit(invalidEmail, emailAddress)) {
        return onSubmit({ ...payload, emailValidationStatus: briteVerifyStatus });
      }
      return handleBriteVerifyStatus(emailAddress, payload);
    }
  };

  const submitForm = (payload) => {
    setOnSubmitLoader();
    const { emailAddress } = payload;
    if (shouldCallSubmit(invalidEmail, emailAddress)) {
      return onSubmit({ ...payload, emailValidationStatus: briteVerifyStatus });
    }
    return handleBriteVerifyStatus(emailAddress, payload);
  };

  useEffect(() => {
    focusFirstFieldForDesktop(setFirstNameFocus, isUserLoggedIn);
  }, []);

  const isLoginFlow = () => {
    return window?.location?.href?.includes('from=SA');
  };
  return (
    <div className={`${className} elem-pt-LRG`}>
      <form onSubmit={handleSubmit(isNewRegisteredFlow ? submitFormNewFlow : submitForm)}>
        <Row fullBleed className="row-form-wrapper">
          <Col ignoreGutter={{ small: true, medium: true, large: true }} colSize={{ small: 6 }}>
            {isBonusPointsEventMessagingEnabled && (
              <div className="bonus-points-event-banner">
                <div className="bonus-points-event-banner-message">
                  <div> {lblLoginBonusPoints1}</div>
                  <img alt="star" src={getIconPath('star-icon-white')} width={12} height={12} />
                  <div>{lblLoginBonusPoints2}</div>
                  <img alt="star" src={getIconPath('star-icon-white')} width={12} height={12} />
                </div>
                <div className="bonus-points-event-banner-account-message">
                  <div>{lblLoginBonusPointsMessage}</div>
                  <Anchor
                    fontSizeVariation="large"
                    className="details"
                    url={'/help-center/coupons-promotions/promoandcoupons'}
                    target="_blank"
                  >
                    {globalGenericLabels[lblDetails]}
                  </Anchor>
                </div>
              </div>
            )}
          </Col>
          <Col ignoreGutter={{ small: true, medium: true, large: true }} colSize={{ small: 6 }}>
            <div className="name-container">
              <Field
                placeholder={globalGenericLabels[lblFirstName]}
                name="firstName"
                id="firstName"
                className="elem-pb-XS"
                component={TextBox}
                dataLocator="first-name-field"
                enableSuccessCheck={false}
                inputRef={firstNameRef}
                spc
              />
              <Field
                placeholder={globalGenericLabels[lblLastName]}
                name="lastName"
                id="lastName"
                component={TextBox}
                dataLocator="last name-field"
                enableSuccessCheck={false}
                className="last-name elem-pb-XS"
                spc
              />
            </div>
          </Col>

          {!isInternationalPhoneNumberEnabled ? (
            <Col ignoreGutter={{ small: true, medium: true, large: true }} colSize={{ small: 6 }}>
              <Field
                placeholder={globalGenericLabels[lblPhoneNumber]}
                name="phoneNumber"
                id="phoneNumber"
                type="tel"
                component={TextBox}
                maxLength={50}
                dataLocator="phone-number-field"
                enableSuccessCheck={false}
                className="elem-pb-XS"
                normalize={formatPhoneNumber}
                spc
              />
            </Col>
          ) : (
            <Col ignoreGutter={{ small: true, medium: true, large: true }} colSize={{ small: 6 }}>
              <Field
                name="phoneNumber"
                component={ReduxFormIntlTelInput}
                className="custom-phone-number elem-pb-XS"
                id="phoneNumber"
                dataLocator="phone-number-field"
                dispatchFormFieldChange={dispatchFormFieldChange}
                labelValue={globalGenericLabels[lblPhoneNumber]}
                containerRef={containerRef}
              />
            </Col>
          )}
          <Col ignoreGutter={{ small: true, medium: true, large: true }} colSize={{ small: 6 }}>
            <Field
              placeholder={
                isCanada()
                  ? getLabelFromCopyOrFromTranslation(
                      'global.addEditAddress.lbl_addEditAddress_postalCode',
                      CREATE_ACCOUNT_LABELS
                    )
                  : globalGenericLabels[lblZipCode]
              }
              name="noCountryZip"
              id="noCountryZip"
              component={TextBox}
              dataLocator="zip-code-field"
              enableSuccessCheck={false}
              normalize={removeSpaces}
              className="elem-pb-XS"
              spc
            />
          </Col>
          <Col
            className={isNewRegisteredFlow ? 'email-hide' : ''}
            ignoreGutter={{ small: true, medium: true, large: true }}
            colSize={{ small: 6 }}
          >
            <Field
              placeholder={globalGenericLabels[lblEmailAddress]}
              name="emailAddress"
              id="emailAddress"
              component={TextBox}
              dataLocator="email-address-field"
              enableSuccessCheck={false}
              normalize={removeSpaces}
              autocomplete="username email"
              className="elem-pb-XS"
              spc
            />
          </Col>
          <Col
            className="position-relative"
            ignoreGutter={{ small: true, medium: true, large: true }}
            colSize={{ small: 6 }}
          >
            <Field
              placeholder={globalGenericLabels[lblPassword]}
              name="password"
              id="new-password"
              component={PasswordField}
              className="elem-pb-XS"
              dataLocator="password-field"
              checkMarkRightMargin="40px"
              enableSuccessCheck={false}
              autocomplete="new-password"
              setInputFocus={setInputFocus}
              spc
              inputRef={inputRef}
              onChange={(e, newValue) => {
                setPasswordValue(newValue);
              }}
              onFocus={() => {
                if (!passwordFieldFocus) {
                  setPasswordFieldFocus(true);
                }
              }}
            />
          </Col>
          {passwordFieldFocus ? (
            <Col
              className="position-relative"
              ignoreGutter={{ small: true, medium: true, large: true }}
              colSize={{ small: 6 }}
            >
              <PasswordIndicator passwordValue={passwordValue} />
            </Col>
          ) : null}

          {userplccCardNumber && userplccCardId && (
            <Col
              className="plcc_checkbox elem-pb-MED"
              ignoreGutter={{ small: true, medium: true, large: true }}
              colSize={{ small: 6 }}
            >
              <Field
                name="plcc_checkbox"
                component={InputCheckbox}
                dataLocator="plcc_checkbox"
                alignCheckbox="top"
              >
                <BodyCopy fontFamily="secondary" fontSize="fs10">
                  <Espot richTextHtml={getPlccLbl} isNativeView={false} />
                </BodyCopy>
              </Field>
            </Col>
          )}
          {isCanada() && isUpdatedCanadaTermsAndConditions ? (
            <>
              <Col
                className="i-agree-checkbox elem-pb-MED"
                ignoreGutter={{ small: true, medium: true, large: true }}
                colSize={{ small: 6 }}
              >
                <Field
                  name="iAgreeTerms"
                  component={InputCheckbox}
                  dataLocator="i-agree-checkbox"
                  disabled={isMakeDefaultDisabled}
                  alignCheckbox="top"
                  genericCheckboxStyle
                >
                  <BodyCopy fontFamily="secondary" fontSize="fs10">
                    <Espot richTextHtml={lblCreateTermsAndConditionsCA} isNativeView={false} />
                  </BodyCopy>
                </Field>
              </Col>
              <Col
                className="i-agree-checkbox elem-pb-MED"
                ignoreGutter={{ small: true, medium: true, large: true }}
                colSize={{ small: 6 }}
              >
                <Field
                  name="iAgreePolicy"
                  component={InputCheckbox}
                  dataLocator="i-agree-checkbox"
                  disabled={isMakeDefaultDisabled}
                  alignCheckbox="top"
                  genericCheckboxStyle
                >
                  <BodyCopy fontFamily="secondary" fontSize="fs10">
                    <Espot richTextHtml={lblCreatePrivacyPolicyCA} isNativeView={false} />
                  </BodyCopy>
                </Field>
              </Col>
              <Col
                className="i-agree-checkbox elem-pb-MED"
                ignoreGutter={{ small: true, medium: true, large: true }}
                colSize={{ small: 6 }}
              >
                <Field
                  name="emailSubscription"
                  component={InputCheckbox}
                  dataLocator="i-agree-checkbox"
                  disabled={isMakeDefaultDisabled}
                  alignCheckbox="top"
                  genericCheckboxStyle
                >
                  <BodyCopy fontFamily="secondary" fontSize="fs10">
                    <Espot richTextHtml={lblMarketingSubscriptionCA} isNativeView={false} />
                  </BodyCopy>
                </Field>
              </Col>
            </>
          ) : (
            <Col
              className="i-agree-checkbox elem-pb-MED"
              ignoreGutter={{ small: true, medium: true, large: true }}
              colSize={{ small: 6 }}
            >
              <Field
                name="iAgree"
                component={InputCheckbox}
                dataLocator="i-agree-checkbox"
                disabled={isMakeDefaultDisabled}
                alignCheckbox="top"
                genericCheckboxStyle
              >
                <BodyCopy fontFamily="secondary" fontSize="fs10">
                  <Espot
                    richTextHtml={`${lblCreateTermsAndConditions} ${lblCreateTermsAndConditions1}`}
                    isNativeView={false}
                  />
                </BodyCopy>
              </Field>
            </Col>
          )}

          <Col
            className="elem-pb-MED"
            ignoreGutter={{ small: true, medium: true, large: true }}
            colSize={{ small: 6 }}
          >
            <Field
              name="rememberMe"
              component={InputCheckbox}
              dataLocator="remember-me-checkbox"
              disabled={isMakeDefaultDisabled}
            >
              <BodyCopy fontFamily="secondary" className="remember-me-text" fontSize="fs10">
                {lblCreateAcntRememberMe}
              </BodyCopy>

              <BodyCopy fontFamily="secondary" fontSize="fs10">
                {lblCreateAcntRememberDevice}
              </BodyCopy>
            </Field>
          </Col>
          <Col
            ignoreGutter={{ small: true, medium: true, large: true }}
            colSize={{ small: 6 }}
            className="card__btn--medium create-account-btn elem-mb-LRG"
          >
            <Button
              buttonVariation="fixed-width"
              fill="BLUE"
              type="submit"
              data-locator="create-account-btn"
              loading={isLoading}
              disabled={isLoading}
              className="rounded-corner"
              ref={containerRef}
              spc
            >
              {isLoginFlow() &&
                !isLoading &&
                !isNewRegisteredFlow &&
                globalGenericLabels[lblCreateAccount]}

              {!isLoginFlow() && !isLoading && isNewRegisteredFlow
                ? getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_LOGIN_LABELS}.${lblLoginCreateAcntBtn}`,
                    GlobalLoginLabels
                  )
                : globalGenericLabels[lblCreateAccount]}
            </Button>
          </Col>
          {!isNewRegisteredFlow && (
            <Col
              ignoreGutter={{ small: true, medium: true, large: true }}
              colSize={{ small: 6 }}
              className="already-account align-center"
            >
              <Anchor
                fontSizeVariation="large"
                className="already-account"
                onClick={onAlreadyHaveAnAccountClick}
              >
                {lblCreateAcntAlready}
              </Anchor>
            </Col>
          )}
        </Row>
      </form>
    </div>
  );
};

const validateMethod = createValidateMethod(
  getStandardConfig([
    'firstName',
    'lastName',
    'phoneNumber',
    'noCountryZip',
    'emailAddress',
    'password',
    'iAgree',
    'iAgreePolicy',
    'iAgreeTerms',
  ])
);

CreateAccountForm = reduxForm({
  form: constants.CREATE_ACCOUNT_FORM, // a unique identifier for this form
  ...validateMethod,
  enableReinitialize: true,
  onSubmitFail: (errors) => scrollToFirstError(errors),
})(CreateAccountForm);

CreateAccountForm.propTypes = {
  isMakeDefaultDisabled: PropTypes.string.isRequired,
  handleSubmit: PropTypes.string.isRequired,
  onAlreadyHaveAnAccountClick: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  userplccCardNumber: PropTypes.string.isRequired,
  userplccCardId: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isUserLoggedIn: PropTypes.bool,
  isLoading: PropTypes.bool,
};

CreateAccountForm.defaultProps = {
  isUserLoggedIn: false,
  isLoading: false,
};

export default withStyles(CreateAccountForm, Styles);
export { CreateAccountForm as CreateAccountFormVanilla };
